import type { ModificationGroupLimits } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Extracts and returns the free addition quantities for each modification group.
 */
export function getFreeAdditionGroups(
  modificationLimits: ModificationGroupLimits,
): FreeAdditionsByGroupName {
  const modificationLimitsKeys = Object.keys(modificationLimits);

  return modificationLimitsKeys.reduce<FreeAdditionsByGroupName>(
    (groups, groupName: string) => {
      const { freeAggregateQuantity } = modificationLimits[groupName];

      return { ...groups, [groupName]: freeAggregateQuantity };
    },
    {},
  );
}

// ─── Types ───────────────────────────────────────────────────────────────────

type FreeAdditionsByGroupName = Record<string, number>;
